import { Paper, styled } from "@mui/material";

export const PaddedPaper = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(2, 2)};
`;
